import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import InspecaoQualidadeService from "service/qualidade/InspecaoQualidadeService";
import { ListMatchModeOptions, TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const inspecaoQualidadeService = new InspecaoQualidadeService();

export default function InspecaoQualidadeListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Inspeções');

    const tipoResuladoFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={inspecaoQualidadeService.getTipoResultadoInspecaoQualidadeFilter()} 
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)} 
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter" 
        />;
    };

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        descricao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        tipoResultado: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="codigoInterno,ASC" service={inspecaoQualidadeService} urlService="/inspecaoQualidade" tituloPagina={titulo}  defaultFilters={defaultFilters} showClearFilterButton nome="inspecaoQualidade">
            <Column field="codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" 
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" 
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="tipoResultado" header="Tipo Resultado" body={(rowData)=> inspecaoQualidadeService.getTipoResultadoLabel(rowData.tipoResultado)} filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={tipoResuladoFilterTemplate}/>
        </BaseListagem>
    )
}